import { createReducer, current } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';

import {
  addCreatives,
  deleteCreative,
  initializeCreatives,
  resizeCreativeImage,
  saveAllCreatives,
  updateCreative,
} from './actions';
import { getCreativesWithCompatibleValues, getUpdatedValues } from './utils';

export default createReducer(
  {},
  /* eslint-disable no-param-reassign */
  {
    [initializeCreatives]: (_state, { payload }) => {
      const creatives = getCreativesWithCompatibleValues(payload);
      const creativesById = keyBy(creatives, 'id');
      return creativesById;
    },
    [addCreatives]: (state, { payload }) => {
      const creatives = getCreativesWithCompatibleValues(payload);
      creatives.forEach(creative => {
        state[creative.id] = creative;
      });
    },
    [updateCreative]: (state, { payload: { id, updates } }) => {
      const compatibleValues = getUpdatedValues(current(state[id]), updates);
      state[id] = {
        ...state[id],
        ...updates,
        ...compatibleValues,
        edited: true,
      };
    },
    [`${saveAllCreatives}-success`]: (state, { payload: savedCreatives }) => {
      savedCreatives.forEach(cr => {
        state[cr.id].edited = false;
      });
    },
    [`${deleteCreative}-success`]: (state, { meta: { id } }) => {
      delete state[id];
    },
    [`${resizeCreativeImage}-success`]: (
      state,
      { payload: updatedCreative },
    ) => {
      state[updatedCreative.id] = { ...updatedCreative, edited: true };
    },
  },
  /* eslint-enable no-param-reassign */
);
